export class Subcategory {

    subCategoryID: number;
    subCategoryName: string;
    categoryID: number; 
    
}